module.exports = __webpack_public_path__ + "static/img/3.01569c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/sp/3.png
// module id = /Q3k
// module chunks = 0